import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';

/**
 * Mobile premium upsell rendered as a dedicated tab in the fixed BottomMenu
 * (autotest `mobilePremiumPlacement: 'bottom_tab'`, arm `v_mobile_premium_tab`).
 * Additive sibling of the other BottomMenu icon items — same IconAnchor /
 * IconContainer / IconLabel structure — pointing non-premium users at upgrade.
 * Only mounted in the variant; the control path (top-right icon) is unchanged.
 */
const PremiumBottomTab = () => (
  <ImpressionWatcher source="nav-bottom-tab-premium">
    <IconAnchor
      href={routes.upgrade_url({
        feature: 'default',
        trigger: 'nav-bottom-tab',
        from_navbar: true,
      })}
    >
      <IconContainer>
        <Icon name="lock" size={24} />
      </IconContainer>
      <IconLabel>Premium</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

export default PremiumBottomTab;
